import { TimeManagementState } from 'types/app/timeManagement';

export const timeManagementInitialState: TimeManagementState = {
  default_booking_length: {
    ranges: [],
  },
  custom_booking_length: [],
};
